<template>
    <div class="registrationWrapper">
        <div class="container">
            <div class="whiteBG-wrap">
                <div class="row">                
                    <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-7">
                        <div class="regForm-wrap">
                            <h2>Group/Admin Login Information</h2>
                            <hr>
                            <login-form />
                        </div>
                    </div>
                    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-5">
                        <login-side-info />
                    </div>                    
                </div>
                <span class="procecss-title">Employer Registration</span>
            </div>
        </div>        
    </div>
</template>
<script>
import LoginForm from '../../components/Registration/LoginInfo/LoginForm.vue'
import LoginSideInfo from '../../components/Registration/LoginInfo/LoginSideInfo.vue'
export default {
    name: 'LoginInfo',
    components: {
        LoginForm,
        LoginSideInfo
    }
}
</script>
<style src="../../assets/css/group-registration.css"></style>